import { useCallback } from 'react';
import { EndPoints } from 'src/config';
import { useFetcher } from 'src/hooks/useFetcher';
import { CreateNewUserInputs } from '../users.types';

type SubmitNewUserCreationResponse = {
  userId: string;
};

export const useSubmitNewUserCreation = () => {
  const { data, error, isLoading, fetcher } = useFetcher<SubmitNewUserCreationResponse | null>(null);

  const submitNewUserCreation = useCallback(
    (data: CreateNewUserInputs) => {
      fetcher(EndPoints.dashboardUserCreation, {
        requiredToken: true,
        method: 'POST',
        body: data,
      });
    },
    [fetcher],
  );

  return {
    submitNewUserCreation,
    userId: data?.userId ?? null,
    error,
    isLoading,
  };
};
